import { cn } from '@/lib/utils';

type KeyValueTableProps = {
  entries: [string, string][];
  keyLabel?: string;
  valueLabel?: string;
  className?: string;
};

export function KeyValueTable({
  entries,
  keyLabel = 'Key',
  valueLabel = 'Value',
  className,
}: KeyValueTableProps) {
  return (
    <div className={cn('overflow-hidden rounded-lg border', className)}>
      <div className="overflow-x-auto">
        <table className="min-w-[26rem] w-full text-sm">
          <thead className="bg-muted/50 ">
            <tr>
              <th className="w-1/3 px-3 py-2 text-left text-xs font-medium text-muted-foreground">
                {keyLabel}
              </th>
              <th className="px-3 py-2 text-left text-xs font-medium text-muted-foreground">
                {valueLabel}
              </th>
            </tr>
          </thead>
          <tbody>
            {entries.map(([key, value]) => (
              <tr key={key} className="border-t">
                <td className="px-3 py-2 font-mono text-xs text-foreground">{key}</td>
                <td className="px-3 py-2 font-mono text-xs text-muted-foreground">{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
